import { render, staticRenderFns } from "./CarrierInfo.vue?vue&type=template&id=86a5194a&scoped=true&"
import script from "./CarrierInfo.vue?vue&type=script&lang=js&"
export * from "./CarrierInfo.vue?vue&type=script&lang=js&"
import style0 from "./CarrierInfo.vue?vue&type=style&index=0&id=86a5194a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a5194a",
  null
  
)

export default component.exports